export function success(value) {
    return { result: 'success', value };
}
export function error(value) {
    return { result: 'error', value };
}
//# sourceMappingURL=result.js.map